export default function FooterPrivacyConsentLink() {
  return (
    <a href="#" data-cc="show-preferencesModal" aria-haspopup="dialog">
      Privacy Preferences
    </a>
  );
}
